<template>
    <div class="app-container room-structure-container">
        <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch"
                 label-width="80px">
            <el-form-item label="房型" prop="xingId">
                <el-select v-model="queryParams.xingId" placeholder="请选择">
                    <el-option
                        v-for="item in fangxingList"
                        :key="item.id"
                        :label="item.fangName"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="房号" prop="fangNo">
                <el-input
                    v-model="queryParams.fangNo"
                    placeholder="请输入房号"
                    clearable
                    @keyup.enter.native="handleQuery"
                />
            </el-form-item>
            <el-form-item label="状态" prop="fangStatus">
                <el-select v-model="queryParams.fangStatus" placeholder="请选择">
                    <el-option
                        v-for="item in fangStatusList"
                        :key="item.id"
                        :label="item.fangStatus"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
            </el-form-item>
        </el-form>

        <el-row :gutter="10" class="mb8">
            <el-col :span="1.5">
                <el-button
                    type="primary"
                    icon="el-icon-plus"
                    size="mini"
                    @click="handleAdd"
                    v-hasPermi="['fang:fangJian:add']"
                >新增
                </el-button>
            </el-col>
            <el-col :span="1.5">
                <el-button
                    type="success"
                    icon="el-icon-edit"
                    size="mini"
                    :disabled="single"
                    @click="handleUpdate"
                    v-hasPermi="['fang:fangJian:edit']"
                >修改
                </el-button>
            </el-col>
            <el-col :span="1.5">
                <el-button
                    type="danger"
                    icon="el-icon-delete"
                    size="mini"
                    :disabled="multiple"
                    @click="handleDelete"
                    v-hasPermi="['fang:fangJian:remove']"
                >删除
                </el-button>
            </el-col>

            <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
        </el-row>
        <!--    <label class="el-form-item__label" style="padding-left: 15px">待入住房间数量： {{ dai }} , 空闲房间数量： {{ kong }} , 出租房间数量： {{ zu }}</label>-->
        <div style="display: grid">

            <label class="el-form-item__label" style="padding-left: 15px">
                待入住房间数量：<label style="color: #ed5565">{{ dai }}</label> ,
                空闲房间数量：<label style="color: #ed5565">{{ kong }}</label> ,
                入住中房间数量：<label style="color: #ed5565">{{ zu }}</label>
            </label>
            <el-card class="room-list-card">
                <el-row :gutter="10">
                    <el-col v-loading="loading" v-for="(room, index) in fangJianList" :key="index" class="room-item"
                            :xs="12" :sm="8" :md="6" :lg="4" :xl="3">
                        <div class="room-card" :style="{ 'background-color': getBgColor(room) }">
                            <div class="room-number">{{ room.xingName }}-{{ room.fangNo }}</div>
                            <div class="room-state">{{ room.fangNo }}</div>
                            <div class="room-owner" v-if="room.fangStatus===1">空闲</div>
                            <div class="room-owner" v-if="room.fangStatus===2">入住中</div>
                            <div class="room-owner" v-if="room.fangStatus===3">待入住</div>
                            <div class="room-owner" v-if="room.fangStatus===4">故障</div>
                            <div class="room-owner" v-if="room.fangStatus===5">仓库</div>
                            <div class="room-debt">
                                <!--                            <span>{{ $t('roomStructure.owe') }}</span>：{{ room.oweAmount }}-->
                                <span>  </span>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-card>
        </div>
        <el-table v-loading="loading" :data="fangJianList" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" align="center"/>
            <el-table-column label="房型" align="center" prop="xingName"/>
            <el-table-column label="房号" align="center" prop="fangNo"/>
            <el-table-column label="状态" align="center" prop="fangStatus">
                <template slot-scope="scope">
                    <label style="color: #67C23A" v-if="scope.row.fangStatus==1">空闲</label>
                    <label style="color: #F56C6C" v-if="scope.row.fangStatus==2">入住中</label>
                    <label style="color: #E6A23C" v-if="scope.row.fangStatus==3">待入住</label>
                    <label style="color: #1296db" v-if="scope.row.fangStatus==4">故障</label>
                    <label style="color: #DC3545" v-if="scope.row.fangStatus==5">仓库</label>
                </template>
            </el-table-column>
            <!--      <el-table-column label="顺序" align="center" prop="imgOrder"/>-->
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        type="text"
                        icon="el-icon-edit"
                        @click="handleUpdate(scope.row)"
                        v-hasPermi="['fang:fangJian:edit']"
                    >修改
                    </el-button>
                    <el-button
                        size="mini"
                        type="text"
                        icon="el-icon-delete"
                        @click="handleDelete(scope.row)"
                        v-hasPermi="['fang:fangJian:remove']"
                    >删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>


        <pagination
            v-show="total>0"
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
        />
        <!-- 添加或修改房间设置对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-form-item label="房型" prop="xingId">
                    <el-select v-model="form.xingId" placeholder="请选择">
                        <el-option
                            v-for="item in fangxingList"
                            :key="item.id"
                            :label="item.fangName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="房号" prop="fangNo">
                    <el-input v-model="form.fangNo" placeholder="请输入房号"/>
                </el-form-item>
                <el-form-item label="房间状态" prop="fangStatus">
                    <el-radio v-model="form.fangStatus" label="1">空闲</el-radio>
                    <el-radio v-model="form.fangStatus" label="2">出租</el-radio>
                    <el-radio v-model="form.fangStatus" label="4">故障</el-radio>
                    <el-radio v-model="form.fangStatus" label="5">仓库</el-radio>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    fangjianList,
    fangNum,
    fangjianById,
    delFangJian,
    addFangJian,
    updateFangJian,
    fangxingList
} from "@/api/homestay/api";

export default {
    name: "FangJian",
    data() {
        return {
            // 根路径
            baseURL: process.env.VUE_APP_BASE_API,
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            // 显示搜索条件
            showSearch: true,
            // 总条数
            total: 0,
            // 房间设置表格数据
            fangJianList: [],
            fangxingList: [],
            fangStatusList: [
                {id: 1, fangStatus: "空闲"},
                {id: 2, fangStatus: "入住中"},
                {id: 3, fangStatus: "待入住"},
                {id: 4, fangStatus: "故障"},
                {id: 5, fangStatus: "仓库"},
            ],
            // 弹出层标题
            title: "",
            kong: "",
            dai: "",
            zu: "",
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                pageNum: 1,
                pageSize: 1000,
                xingId: null,
                fangNo: null,
                openId: null,
                fangStatus: null,
                imgOrder: null,
            },
            // 表单参数
            form: {},
            // 表单校验
            rules: {
                id: [
                    {required: true, message: "$comment不能为空", trigger: "blur"}
                ],
                xingId: [
                    {required: true, message: "房型id不能为空", trigger: "blur"}
                ],
                fangNo: [
                    {required: true, message: "房号不能为空", trigger: "blur"}
                ],
                openId: [
                    {required: true, message: "openid不能为空", trigger: "blur"}
                ],
                fangStatus: [
                    {required: true, message: "状态 1空闲 2已出租不能为空", trigger: "blur"}
                ],
                imgOrder: [
                    {required: true, message: "顺序不能为空", trigger: "blur"}
                ],
                delFlag: [
                    {required: true, message: "删除标志不能为空", trigger: "blur"}
                ],
            }
        };
    },
    created() {
        this.getList();
        fangxingList(this.queryParams).then(response => {
            this.fangxingList = response.data;
        })
    },
    methods: {
        /** 查询房间设置列表 */
        getList() {
            this.loading = true;
            fangjianList(this.queryParams).then(response => {
                this.fangJianList = response.data;
                this.total = response.total;
                this.loading = false;
                this.getFangNum();
            });
        },
        getFangNum() {
            fangNum(this.queryParams).then(response => {
                this.kong = response.data.kong;
                this.zu = response.data.zu;
                this.dai = response.data.dai;
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.reset();
        },
        // 表单重置
        reset() {
            this.form = {
                id: null,
                xingId: null,
                fangNo: null,
                openId: null,
                fangStatus: 0,
                imgOrder: null,
                delFlag: null,
            };
            this.resetForm("form");
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.resetForm("queryForm");
            this.handleQuery();
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.id)
            this.single = selection.length !== 1
            this.multiple = !selection.length
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.reset();
            this.open = true;
            this.title = "添加房间设置";
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.reset();
            const idss = (row.id || this.ids.join(','));
            console.log(idss)
            fangjianById({'id': idss}).then(response => {
                this.form = response.data;
                this.form.fangStatus = this.form.fangStatus.toString()
                this.open = true;
                this.title = "修改房间设置";
            });
        },
        /** 提交按钮 */
        submitForm() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    if (this.form.id != null) {
                        updateFangJian(this.form).then(() => {
                            this.$modal.msgSuccess("修改成功");
                            this.open = false;
                            this.getList();
                        });
                    } else {
                        addFangJian(this.form).then(() => {
                            this.$modal.msgSuccess("新增成功");
                            this.open = false;
                            this.getList();
                        });
                    }
                }
            });
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            const idss = (row.id || this.ids.join(','));

            this.$modal.confirm('是否确认删除数据项？').then(function () {
                console.log('111' + idss);
                return delFangJian({'ids': idss});
            }).then(() => {
                this.getList();
                this.$modal.msgSuccess("删除成功");
            }).catch(() => {
            });
        },
        /** 导出按钮操作 */
        handleExport() {
            // this.download('fang/fangJian/export', {
            //     ...this.queryParams
            // }, `fangJian_${new Date().getTime()}.xlsx`)
        },
        getBgColor(room) {
            if (room.fangStatus === 0) {
                return '#DC3545'
            }
            if (room.fangStatus === 1) {
                return '#67C23A'
            }
            if (room.fangStatus === 2) {
                return '#F56C6C'
            }
            if (room.fangStatus === 3) {
                return '#E6A23C'
            }
            if (room.fangStatus === 4) {
                return '#1296db'
            }
            if (room.fangStatus === 5) {
                return '#DC3545'
            }
            return "#1296db"
        },
    }
};
</script>

<style lang="scss" scoped>
.room-structure-container {
    padding: 20px;
    height: 100%;

    .room-list-card {
        margin-bottom: 20px;

        .floor-title {
            font-size: 16px;
            font-weight: bold;
            padding: 10px 0;
        }

        .floor-row {
            margin-bottom: 20px;
        }

        .room-item {
            margin-bottom: 10px;
        }

        .room-card {
            color: #fff;
            border-radius: 5px;
            padding: 10px;
            cursor: pointer;
            transition: all 0.3s;
            height: 100%;

            &:hover {
                transform: translateY(-3px);
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            }

            .room-number {
                font-weight: bold;
                margin-bottom: 5px;
            }

            .room-state,
            .room-owner,
            .room-debt {
                margin-bottom: 3px;
                font-size: 12px;
            }
        }
    }
}
</style>
